// extracted by mini-css-extract-plugin
module.exports = {"servicos":"styles_servicos__25k6-","btn":"styles_btn__4jRRi","title":"styles_title__35K-B","desc":"styles_desc__1DKqy"};